// Mock data for Precision Mobile Detailing

export const businessInfo = {
  name: "Precision Mobile Detailing",
  phone: "(909) 654-4475",
  email: "precisiondetailing909@gmail.com",
  rating: 5.0,
  reviewCount: 30,
  hours: "7 AM - 7 PM",
  daysOpen: "Monday - Saturday",
  serviceArea: "Redlands and Surrounding Areas"
};

export const services = [
  {
    id: 1,
    name: "Full Detail Package",
    description: "Complete interior and exterior detailing service. Includes deep cleaning, polishing, waxing, and protection.",
    features: [
      "Complete exterior wash and dry",
      "Clay bar treatment",
      "Machine polish and wax",
      "Full interior deep clean",
      "Leather conditioning",
      "Engine bay cleaning",
      "Tire shine and wheel detailing"
    ],
    duration: "4-6 hours",
    image: "https://images.unsplash.com/photo-1761934658038-d0e6792378b1"
  },
  {
    id: 2,
    name: "Clay and Seal Package",
    description: "Professional clay bar treatment with sealant protection for a smooth, glossy finish.",
    features: [
      "Premium exterior wash",
      "Clay bar treatment",
      "Paint sealant application",
      "Wheel and tire cleaning",
      "Glass cleaning",
      "Trim restoration"
    ],
    duration: "2-3 hours",
    image: "https://images.unsplash.com/photo-1761312834150-4beefff097a7"
  }
];

export const gallery = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1731988666842-e5f82bd10351",
    title: "Luxury Vehicle Detail",
    category: "Full Detail"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1771491237209-b89bc7290588",
    title: "Interior Detailing",
    category: "Interior"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1771491237067-5d108e956e73",
    title: "Professional Equipment",
    category: "Process"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1761934658038-d0e6792378b1",
    title: "Exterior Polish",
    category: "Exterior"
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1761312834150-4beefff097a7",
    title: "Clay Treatment",
    category: "Clay & Seal"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "JL Concrete (Russell Adams)",
    rating: 5,
    text: "I recently had the pleasure of working alongside Precision Mobile Detailing. As a company that takes pride in clean professional job sites we were seriously impressed. Got my personal vehicle and the company truck cleaned up right at the job site.",
    date: "1 hour ago"
  },
  {
    id: 2,
    name: "Polki 999",
    rating: 5,
    text: "Excellent service, very professional, and great attention to detail. Highly recommended.",
    date: "1 hour ago"
  },
  {
    id: 3,
    name: "Jocelyn Sanchez",
    rating: 5,
    text: "I had an amazing experience with Precision car detailing service! He did an excellent job my car was left absolutely spotless, both inside and out. Every detail was taken care of, and it honestly looked brand new again.",
    date: "9 hours ago"
  },
  {
    id: 4,
    name: "Veronica",
    rating: 5,
    text: "Booked Precision Mobile Detailing and honestly blew my expectations. My car looked brand new after the interior detail. Seats, carpets, everything spotless. Professional, on time, and you can tell he actually cares about the work.",
    date: "1 day ago"
  }
];

export const mockAppointments = [];

export const addMockAppointment = (appointment) => {
  mockAppointments.push({
    id: Date.now(),
    ...appointment,
    status: "pending",
    createdAt: new Date().toISOString()
  });
  return mockAppointments[mockAppointments.length - 1];
};
